"use strict";
define('components/ajax',[], function() {
    /*
     * This module encapsulates common AJAX behavior.
     *
     * Usage:
     *
     *
     * All responses to XHRs are JSON object with the following structure:
     *   {
     *      'status': 'ok' or 'error',
     *      'message': string message that augments the status
     *      'location': URL to redirect to or string 'reload' to reload the page.
     *      'modal': {
     *          'sel': CSS selector for the modal ('#small-modal', '#large-modal', etc.)
     *          'content': HTML for the modal (includes header, body, and footer)
     *      }
     *      'waiting_modal': {
     *          'title': Text to show in the modal title
     *          'body': Text to show in the modal body
     *      }
     *      'updates': {
     *          <selector>: HTML Fragment to replace content of the DOM node with.
     *      }
     *      'replaces': {
     *          <selector>: HTML Fragment to REPLACE the DOM node with (to replace the CONTENT, see 'updates').
     *      }
     *      'inserts': [{
     *          'sel': CSS selector for the DOM where the insert should be made
     *          'place': 'inner' | 'after' | before'
     *          'content': HTML Fragment to insert into the DOM
     *      }]
     *      'removes': [ <selector to remove> ]  # removes with delay and animation
     *      'remove_immediates': [ <selector to remove> ]  # removes w/out delay or animation
     *      'set_attr': {
     *          <selector>: {<attr_name>: <attr_value>}  (eg. 'a.btn': {'href': '#'})
     *      }
     *      'set_prop': {
     *          <selector>: {<property_name>: <property_value>}  (eg. 'a.btn': {'disabled': False})
     *      }
     *      'set_data': {
     *          <selector>: {<data_attr_name>: <data_attr_value>}  (eg. '#position-list': {'array': []})
     *      }
     *      'classname': {
     *          <selector>: {'add'|'remove': <class>}  (eg. 'a.btn': {'remove': 'hidden'})
     *      }
     *      'fadein': {
     *          <selector>: selector for the HTML element to fade-in (assumes it already has the class 'fade'
     *      }
     *      'alert': {
     *          status: bootstrap alert status ('success', 'info', 'warning', 'danger')
     *          message: bootstrap alert message to display
     *      }
     *      'triggers': [{
     *          event_type: Javascript event type ('click', 'blur', 'focus', 'jsq:xxx')
     *          target_sel: selector for the event target
     *      }]
     *   }
     */

    var requests = {};
    return function(path, opts) {
        var POLL_WAIT = 3000;  // Wait 3 seconds between polls
        var POLL_MAX_COUNT = 900;  // Max 900 polls (2700 seconds = 45 minutes)

        var options = $.extend({formData: null, onSuccess: null, onFailure: null, onError: null, onComplete: null, type: 'POST'}, opts);

        // Blocks POST requests if an identical one is in transit (e.g., double-clicks from form submissions).
        var hashedFormData = require('components/utils').hashFormData(options.formData)
        if (options.type === 'POST') {
            var requestKey = path + '-' + options.type + '-' + hashedFormData;
            var isRequestSending = Object.prototype.hasOwnProperty.call(requests, requestKey) && requests[requestKey] === true;

            if (isRequestSending) {
                return $.ajax(); // ajax.js returns a jqXHR object. Return an empty one in case properties need to be read.
            }

            requests[requestKey] = true;
        }

        // Add the CSRF token if missing from formData
        if (!options.formData) {
            options.formData = new FormData();
        }
        options.formData.append('csrf_token', $('meta[name=csrf_token]').attr('content'));

        var handleResponseModal = function(response) {
            if (response.modal) {
                $('#waiting-modal').modal('hide');

                var modalNode = $(response.modal.sel);
                if (modalNode.length == 0) {
                    return true;
                }

                modalNode.modal('show')
                         .find('.modal-content')
                         .html(response.modal.content);
                require('components/modal').modalLoaded(modalNode);
                return true;
            }
            return false;
        };

        var handleSetProp = function(result) {
            var changedDOM = false;
            if (result.set_prop) {
                for (var selector in result.set_prop) {
                    for (var prop_name in result.set_prop[selector]) {
                        $(selector).prop(prop_name, result.set_prop[selector][prop_name]);
                        changedDOM = true;
                    }
                }
            }

            return changedDOM;
        }

        var handleResponseReplace = function(response) {
            var changedDom = false;
            if (response.replaces) {
                for (var selector in response.replaces) {
                    $(selector).replaceWith(response.replaces[selector]);
                    changedDom = true;
                    // possibly rerender pillars
                    if(typeof window.__jsqRenderPillars__ === 'function') {
                        window.__jsqRenderPillars__();
                    }
                }
                require(['components/dom_setup'], function(domSetup) {
                    for (var selector in response.replaces) {
                        domSetup.init($(selector));
                    }
                });
                if (response.component) {
                    require(['components/'+response.component], function(component) {
                        component.init($(selector));
                    });
                }
            }
            return changedDom;
        };

        var handleLocationAction = function(response) {
            // If the server wants us to redirect, just assume any remaining non-submitted forms are stale.
            require('components/form').clearAllSaveWarnings();

            if (response.location == 'reload') {
                if (response.clear_query_string) {
                    window.location.search = '';
                } else {
                    window.location.reload();
                }
            } else {
                window.location = response.location;
            }
        }

        var handleAjaxMessage = function(response) {
            if (response.message) {
                $('#waiting-modal').modal('hide');

                var alert_message = $('#alert-message');
                if (response.status === "error") {
                    // Place error icon next to the error message
                    alert_message.html('<div class="alert-danger-container"><span class="glyphicon glyphicon-exclamation-sign"></span><div>' + response.message + '</div></div>')
                } else {
                    alert_message.html(response.message);
                }
                alert_message.addClass('alert-danger')
                alert_message.removeClass('hidden')

                // Scroll to the top if the error alert is not in the view port
                var viewportTop = $(window).scrollTop();
                if (alert_message.offset().top < viewportTop) {
                    $('html,body').animate({scrollTop: alert_message.offset().top - $('.navbar-fixed-top').offset().top});
                }
                $('.show-expanded-content').on('click', function() {
                    $(this).closest('.expandable-alert').find('.expanded-content').show();
                    $(this).css('cursor', 'auto')
                });
            }
        }

        var handleAjaxUpdates = function(response) {
            if (response.updates) {
                for (var selector in response.updates) {
                    $(selector).html(response.updates[selector]);
                }
                require(['components/dom_setup'], function(domSetup) {
                    for (var selector in response.updates) {
                        domSetup.init($(selector));
                    }
                });
            }
        }

        var scrollToErrorMessage = function() {
            // Scroll to the top if the error alert is not in the view port
            var alert_message = $('#alert-message');
            var viewportTop = $(window).scrollTop();
            if (alert_message.offset().top < viewportTop) {
                $('html,body').animate({scrollTop: alert_message.offset().top - $('.navbar-fixed-top').offset().top});
            }
        };

        var handleTriggers = function(response) {
            if (response.triggers) {
                    $.each(response.triggers, function(index, value) {
                        var SUPPORTED_EVENT_TYPES = ['click', 'blur', 'focus'];
                        if (SUPPORTED_EVENT_TYPES.indexOf(value.event_type) == -1 &&
                            value.event_type.substring(0, 4) != 'jsq:') {
                            return;
                        }
                        // delay the event triggering
                        var event_payload = value.event_payload || [];
                        window.setTimeout(function() {
                            $(value.target_sel).trigger(value.event_type, event_payload);
                        }, 10);
                    });
                }
        };

        var ajaxSettings = {
            url: path,
            type: options.type,
            data: options.formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function(result) {
                // All nok statuses terminate further processing
                if (result.status != 'ok') {
                    var preventDefault = false;
                    if (options.onFailure) {
                        preventDefault = options.onFailure(result);
                    }
                    if (preventDefault) {
                        return;
                    }
                    handleAjaxMessage(result);
                    handleResponseReplace(result);
                    handleResponseModal(result);
                    handleTriggers(result);
                    return;
                }

                // Since we know this is a success, we can grab the form ID from `options.formData`
                // and call `resetSaveWarningForFormId()`.
                if (options.formData && typeof options.formData.get === 'function') {
                    var formId = options.formData.get('__formid__');
                    if (formId) {
                        require('components/form').resetSaveWarningForFormId(formId);
                    }
                }

                // Sometimes, the page is updated and a download is triggered via the
                // 'location' setting (eg. nda signature page). Process the update first.
                handleAjaxUpdates(result);

                if (result.location) {
                    handleLocationAction(result);
                    return;
                }

                if (handleResponseModal(result)) {
                    return;
                }

                if (options.onSuccess) {
                    var preventDefault = options.onSuccess(result);
                    if (preventDefault) {
                        return;
                    }
                }

                if (result.waiting_modal) {
                    // Clear any alerts
                    var alert_message = $('#alert-message');
                    alert_message.html('');
                    alert_message.removeClass('alert-danger');
                    alert_message.addClass('hidden');

                    var modalNode = $('#waiting-modal');
                    if (modalNode.length != 0) {
                        if (result.waiting_modal.close) {
                            modalNode.modal('hide');
                        } else {
                            if (result.waiting_modal.title && result.waiting_modal.body) {
                                var modalBody = result.waiting_modal.body;
                                if (result.waiting_modal.total_count && result.waiting_modal.poll_url) {
                                    modalBody += '<br/><br/>' +
                                    '<div class="progress">' +
                                    '  <div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%">' +
                                    '    <span class="sr-only">0% Complete</span>' +
                                    '  </div>' +
                                    '</div>';
                                }
                                var modalContent =
                                    '<div class="modal-header">' +
                                    '  <h4 class="modal-title" id="waiting-title">' +
                                    '    <img src="/static/spinner_sm.gif" width="16" height="16">&nbsp;' +
                                    result.waiting_modal.title +
                                    '  </h4>' +
                                    '</div>' +
                                    '<div class="modal-body">' +
                                    modalBody +
                                    '</div>';
                                modalNode.find('.modal-content').html(modalContent);
                            }
                            if (result.waiting_modal.poll_url) {
                                var pollCount = 0;
                                var makeRequest = function() {
                                    setTimeout(function(){
                                        $.ajax({
                                            url: result.waiting_modal.poll_url,
                                            processData: false,
                                            contentType: false,
                                            dataType: 'json',
                                            success: function(result) {
                                                if (typeof result.current_count !== 'undefined' &&
                                                    typeof result.total_count !== 'undefined') {
                                                    var pc = Math.round(result.current_count / result.total_count * 100);
                                                    modalNode.find('.modal-body .progress-bar').width(pc + "%");
                                                }
                                                if (typeof result.location !== 'undefined' && result.location) {
                                                    handleLocationAction(result);
                                                }
                                                handleAjaxUpdates(result);

                                                // Sometimes we need to make a new ajax call based on polling results
                                                if (result.ajax_url) {
                                                    $.ajax({
                                                        url: result.ajax_url,
                                                        type: options.type,
                                                        data: options.formData,
                                                        processData: false,
                                                        contentType: false,
                                                        dataType: 'json',
                                                        success: function(result) {
                                                            handleAjaxUpdates(result);
                                                            if (typeof result.location !== 'undefined' && result.location) {
                                                                handleLocationAction(result);
                                                                return;
                                                            }
                                                            handleAjaxMessage(result);
                                                            handleResponseReplace(result);
                                                        }
                                                    })
                                                }

                                                ajaxChangedDOM = handleSetProp(result) || ajaxChangedDOM;

                                                pollCount += 1;
                                                var job_done = (result.job_status == 'Completed') ||
                                                               (result.job_status == 'Error');
                                                var too_long = pollCount > POLL_MAX_COUNT;
                                                if (job_done || too_long) {
                                                    var error_message = null;
                                                    if (typeof result.error_message !== 'undefined' && result.error_message) {
                                                        error_message = result.error_message;
                                                    } else if (pollCount > POLL_MAX_COUNT) {
                                                        error_message = 'Request timed out.'
                                                    }
                                                    if (error_message) {
                                                        alert_message.html(error_message);
                                                        alert_message.addClass('alert-danger');
                                                        alert_message.removeClass('hidden');
                                                        scrollToErrorMessage();
                                                    }
                                                    modalNode.modal('hide');

                                                    if (handleResponseModal(result)) {
                                                        return;
                                                    }
                                                } else {
                                                    makeRequest();
                                                }
                                            },
                                        });
                                    }, POLL_WAIT);
                                };

                                makeRequest();
                            }
                            modalNode.modal('show');
                        }
                    }
                }

                // we might want to poll without showing a waiting modal (for instance, polling the task which
                // renders the PDF for a publication preview)
                else if (result.poll_url) {
                    // Clear any alerts
                    var alert_message = $('#alert-message');
                    alert_message.html('');
                    alert_message.removeClass('alert-danger');
                    alert_message.addClass('hidden');
                    var pollCount = 0;
                    var makeRequest = function() {
                        setTimeout(function(){
                            $.ajax({
                                url: result.poll_url,
                                processData: false,
                                contentType: false,
                                dataType: 'json',
                                success: function(result) {
                                    if (typeof result.location !== 'undefined' && result.location &&
                                        typeof result.selector !== 'undefined' && result.selector &&
                                        typeof result.attributeName !== 'undefined' && result.attributeName) {
                                        $(result.selector).attr(result.attributeName, result.location);

                                        // the .parent() call below is an unfortunate hack to deal with the fact that
                                        // custom event listeners on 'embed' elements do not work properly
                                        $(result.selector).parent().trigger('attribute-change');
                                    }

                                    handleAjaxUpdates(result);

                                    // Sometimes we need to make a new ajax call based on the polling results
                                    if (result.ajax_url) {
                                        $.ajax({
                                            url: result.ajax_url,
                                            type: options.type,
                                            data: options.formData,
                                            processData: false,
                                            contentType: false,
                                            dataType: 'json',
                                            success: function(result) {
                                                handleAjaxUpdates(result);
                                                if (typeof result.location !== 'undefined' && result.location) {
                                                    handleLocationAction(result);
                                                    return;
                                                }
                                                handleAjaxMessage(result);
                                                handleResponseReplace(result);
                                            }
                                        })
                                    }

                                    ajaxChangedDOM = handleSetProp(result) || ajaxChangedDOM;

                                    pollCount += 1;
                                    var job_done = (result.job_status == 'Completed') ||
                                        (result.job_status == 'Error');
                                    var too_long = pollCount > POLL_MAX_COUNT;
                                    if (job_done || too_long) {
                                        var error_message = null;
                                        if (typeof result.error_message !== 'undefined' && result.error_message) {
                                            error_message = result.error_message;
                                        } else if (pollCount > POLL_MAX_COUNT) {
                                            error_message = 'Request timed out.'
                                        }
                                        if (error_message) {
                                            alert_message.html(error_message);
                                            alert_message.addClass('alert-danger');
                                            alert_message.removeClass('hidden');
                                            scrollToErrorMessage();
                                        }
                                    } else {
                                        makeRequest();
                                    }
                                }
                            });
                        }, POLL_WAIT);
                    };
                    makeRequest();
                }

                // Perform all DOM updates synchronously so that
                // we do not run into race conditions with subsequent code
                // that assumes the DOM was updated synchronously.
                // Do not wait for require() because it runs asynchronously.

                var ajaxChangedDOM = false;

                ajaxChangedDOM = handleResponseReplace(result);

                if (result.removes) {
                    $.each(result.removes, function(index, sel) {
                        ajaxChangedDOM = true;
                        $(sel).hide('slow', function(){ $(sel).remove(); });
                    });
                }

                if (result.remove_immediates) {
                    $.each(result.remove_immediates, function(index, sel) {
                        ajaxChangedDOM = true;
                        $(sel).remove();
                    });
                }

                if (result.inserts) {
                    $.each(result.inserts, function(index, value) {
                        ajaxChangedDOM = true;
                        if (value.place == 'inner') {
                            $(value.sel).html(value.content);
                        } else if (value.place == 'after') {
                            $(value.sel).after(value.content);
                        } else if (value.place == 'before') {
                            $(value.sel).before(value.content);
                        } else if (value.place == 'prepend') {
                            $(value.sel).prepend(value.content);
                        } else if (value.place == 'append') {
                            $(value.sel).append(value.content);
                        }
                    });
                    require(['components/dom_setup'], function(domSetup) {
                        $.each(result.inserts, function(index, value) {
                            domSetup.init($(value.sel));
                        });
                    });
                    if (result.component) {
                        require(['components/'+result.component], function(component) {
                            $.each(result.inserts, function(index, value) {
                                component.init($(value.sel));
                            });
                        });
                    }
                }

                if (result.set_attr) {
                    for (var selector in result.set_attr) {
                        for (var attr_name in result.set_attr[selector]) {
                            $(selector).attr(attr_name, result.set_attr[selector][attr_name]);
                            ajaxChangedDOM = true;
                        }
                    }
                }

                ajaxChangedDOM = handleSetProp(result) || ajaxChangedDOM;

                if (result.set_data) {
                    for (var selector in result.set_data) {
                        for (var data_name in result.set_data[selector]) {
                            $(selector).data(data_name, result.set_data[selector][data_name]);
                        }
                    }
                }

                if (result.classname) {
                    for (var selector in result.classname) {
                        for (var action in result.classname[selector]) {
                            if (action == 'add') {
                                $(selector).addClass(result.classname[selector]['add']);
                            } else if (action == 'remove') {
                                $(selector).removeClass(result.classname[selector]['remove']);
                            }
                        }
                    }
                    ajaxChangedDOM = true;
                }

                if (result.fadein) {
                    window.setTimeout(function() {
                        for (var i=0; i<result.fadein.length; i++) {
                            $(result.fadein[i]).addClass('in');
                        }
                    }, 1);
                }

                if (result.alert) {
                    var alert_message = $('#alert-message');
                    alert_message.html(result.alert.message);

                    require(['components/dom_setup'], function(domSetup) {
                        domSetup.init(alert_message);
                    });

                    if (result.alert.status) {
                        // Remove all alert-* classes and add the one in the result
                        alert_message.removeClass (function (index, css) {
                            return (css.match (/(^|\s)alert-\S+/g) || []).join(' ');
                        });
                        alert_message.removeClass('hidden');
                        alert_message.addClass('alert-'+result.alert.status);

                        if (result.alert.dismissible) {
                            alert_message.addClass('alert-dismissible');
                            alert_message.prepend(
                                '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
                            );
                        }

                        scrollToErrorMessage();
                    } else {
                        alert_message.addClass('hidden')
                    }
                }

                handleTriggers(result);

                if (ajaxChangedDOM) {
                    $(window).trigger('jsq:ajaxChangedDOM');
                }

            },
            error: function(result) {
                if (options.onError) {
                    options.onError(result);
                }
            },
            complete: function(result) {
                delete requests[requestKey];

                if (options.onComplete) {
                    options.onComplete(result.responseJSON);
                }
            },
        };

        if (options.xhr) {
            ajaxSettings.xhr = options.xhr;
        } else {
            ajaxSettings.xhr = function() {
                var xhr = $.ajaxSettings.xhr();
                if (options.onUploadProgress) {
                    xhr.upload.onprogress = options.onUploadProgress;
                }
                return xhr;
            };
        }

        return $.ajax(ajaxSettings);
    };

});

